import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { FormsModule } from '@angular/forms'
import { BaseApiService } from '../base-api.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

import { Router } from '@angular/router';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  username: string;
  password: string;

  constructor(private baseAPI: BaseApiService, private spinnerService: Ng4LoadingSpinnerService, private router: Router) {
  
  }

  ngOnInit() {
   
   
    if(this.spinnerService!=undefined){
      this.spinnerService.hide();
    }
  }
  login() {
   
    
   // this.router.navigate(['/dashboard']);
   
    this.spinnerService.show();
    this.baseAPI.callLoginApi(this.username, this.password).then(data => {
      this.spinnerService.hide();
      //console.log('Success' + JSON.stringify(data));
      this.router.navigate(['/dashboard']);
    }, (err) => {
     
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
  });



  }
  
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts